<template>
<div class="processList">
  <div class="processrows_box">
    <div class="processrows">
      <div v-if="tableData.length === 0">
        <span style="color: black;font-size:10px;">暂无数据</span>
      </div>
      <el-button style="float: right" @click="exportSignData">导出报名</el-button>
      <div v-if="tableData.length!=0"><span style="font-size: x-large;color: rgb(137,12,12);font-weight: bold">报名表</span></div>
      <div class="row_box" v-for="(item,index) in tableData" :key="index">
        <div class="row">
          <div class="row_date">
            <div class="row_date_left">{{item.day}}</div>
            <div class="row_date_right">
              <div class="row_date_month">{{item.month}}</div>
              <div class="row_date_year">{{item.year}}</div>
            </div>
          </div>
          <div class="row_content" >
            <div class="row_sign">
              <span>{{item.username}}</span>
              <span v-if="item.signState=='A'">(待审核)</span>
              <span v-else-if="item.signState=='B'">(通过)</span>
              <span v-else>(未通过)</span>
            </div>
            <div class="row_name2">{{item.uniName}}</div>
          </div>
          <el-button size="small" type="primary" v-if="item.signState=='A'" @click="processThis(item)">审核</el-button>
          <el-button size="small" type="primary" v-else @click="processThis(item)">编辑</el-button>
        </div>
      </div>
    </div>
    <div class="page" v-if="tableData.length > 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[2, 4, 6, 8,10]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next"
          background
          :total="totalNum">
      </el-pagination>
    </div>
  </div>
</div>
  <el-dialog
      :append-to-body="true"
      title="报名信息"
      v-model="dialog1">
      <span class="hand-up">应缴费:   {{this.sign2.howMuchRMB}}  人民币（或{{this.sign2.howMuchCAD}}加元）</span>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>姓：{{this.sign2.firstName}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>名：{{this.sign2.lastName}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="7">
        <span>是否需要发票：</span>
      </el-col>
      <el-col :span="7">
        <span v-if="this.sign2.isReceipt == 0">需要</span>
        <span v-if="this.sign2.isReceipt == 1">不需要</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="7">
        <span>用户类型：</span>
      </el-col>
      <el-col :span="7">
        <span v-if="this.sign2.type == 'A'">IEEE SMC 学生会员</span>
        <span v-if="this.sign2.type == 'B'">IEEE SMC 会员</span>
        <span v-if="this.sign2.type == 'C'">IEEE/INCOSE 学生会员</span>
        <span v-if="this.sign2.type == 'D'">IEEE/INCOSE 成员</span>
        <span v-if="this.sign2.type == 'E'">非IEEE 学生</span>
        <span v-if="this.sign2.type == 'F'">非IEEE 会员</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="7">
        <span>参与方式：</span>
      </el-col>
      <el-col :span="7">
        <span v-if="this.sign2.participateMethod == 'A'">线上</span>
        <span v-if="this.sign2.participateMethod == 'B'">线下</span>
      </el-col>
    </el-row>

    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="7">
        <span>性别：</span>
      </el-col>
      <el-col :span="7">
        <span v-if="this.sign2.gender == 'f'">女</span>
        <span v-if="this.sign2.gender == 'm'">男</span>
        <span v-if="this.sign2.gender == 'n'">未披露</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>国籍：{{this.sign2.nationality}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="27">
        <span>你是为参加本暑期班加入IEEE的？：</span>
      </el-col>
      <el-col :span="27">
        <span v-if="this.sign2.questionOne == '0'">No</span>
        <span v-if="this.sign2.questionOne == '1'">Yes</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="27">
        <span>你是为参加本暑期班加入SMCS的？：</span>
      </el-col>
      <el-col :span="27">
        <span v-if="this.sign2.questionTwo == '0'">No</span>
        <span v-if="this.sign2.questionTwo == '1'">Yes</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="27">
        <span>你愿意与IEEE及其赞助者分享你的注册信息吗？：</span>
      </el-col>
      <el-col :span="27">
        <span v-if="this.sign2.questionThree == '0'">No</span>
        <span v-if="this.sign2.questionThree == '1'">Yes</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>出生日期：{{this.sign2.birthDateStr}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>报名时间：{{this.sign2.createTime}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>附属机构：{{this.sign2.affiliation}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>职称：{{this.sign2.position}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>研究兴趣：{{this.sign2.researchInterests}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>联系地址：{{this.sign2.contactAddress}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>电话：{{this.sign2.telephone}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>电子邮箱：{{this.sign2.email}}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>身份凭证图片：<div v-for="(item,index) in images" :key="index" style="text-align: center" >
<!--          <img :src="item" style="height: 100px;width: 200px;">-->
          <el-image
              style="width: 200px; height: 100px"
              :src="item"
              :zoom-rate="1.2"
              :preview-src-list="[item]"
              :initial-index="4"
              fit="cover"
          />
               </div></span>
      </el-col>
    </el-row>
<!--    <div class="demo-image__lazy" style="padding: 20px 0 0 0">-->
<!--      <el-image v-for="(item,index) in images" :key="url" :src="item" lazy   style="width: 200px; height: 100px"></el-image>-->
<!--    </div>-->
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>缴费图片：<div v-for="(item,index) in images2" :key="index" style="text-align: center">
<!--          <img :src="item" style="height: 100px;width: 200px;" >-->
          <el-image
              style="width: 200px; height: 100px"
              :src="item"
              :zoom-rate="1.2"
              :preview-src-list="[item]"
              :initial-index="4"
              fit="cover"
          />
               </div></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="27">
        <span>审核状态：</span>
      </el-col>
      <el-col :span="27">
        <input type="radio" name="radios3" value="A" v-model="this.sign2.signState" v-show="this.sign2.signState=='A'"><label v-show="this.sign2.signState=='A'">待审核</label>
        <input type="radio" name="radios3" value="B" v-model="this.sign2.signState"><label>通过</label>
        <input type="radio" name="radios3" value="C" v-model="this.sign2.signState"><label>未通过</label>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;" v-if="this.sign2.signState == 'A' || this.sign2.signState == 'C' ">
      <el-col :span="24">
        <span>审核意见：<el-input
            v-model="this.sign2.comments"
            placeholder="请输入审核意见"
            style="padding: 10px 0 5px 0;"
        ></el-input></span>
      </el-col>
    </el-row>
    已支付
    <el-input
        v-model="this.sign2.amount"
        type="number"
        placeholder="请输入已支付金额(保留两位小数)"
        @keydown.native="handleInput2"
        style="margin:0 0 5px 0;"
    ></el-input>
<!--    <el-input-->
<!--        v-model="this.sign2.currency"-->
<!--        placeholder="请输入已支付币种"-->
<!--        style="margin:0 0 5px 0;"-->
<!--    ></el-input>-->
    <el-select v-model="this.sign2.currency" placeholder="请输入已支付币种">
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
<!--    <el-button @click="processOk1(this.sign2.id)">通过</el-button>
    <el-button @click="processNo(this.sign2.id)">不通过</el-button>-->
    <el-button @click="processOk1(this.sign2.id)">确定</el-button>
  </el-dialog>
<!--  <el-dialog
      :append-to-body="true"
      title="报名信息"
      v-model="dialog2">
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>已支付金额：<el-input v-model="this.sign.amount" placeholder="请输入已支付金额"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>已支付币种：<el-input v-model="this.sign.currency" placeholder="请输入已支付币种"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="7">
        <span>是否需要发票：</span>
      </el-col>
      <el-col :span="7">
        <input type="radio" name="radios1" value="0" v-model="this.sign.isReceipt"><label>不需要</label>
        <input type="radio" name="radios1" value="1" v-model="this.sign.isReceipt"><label>需要</label>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="27">
        <span>用户类型：</span>
      </el-col>
      <el-col :span="27">
        <input type="radio" name="radios2" value="A" v-model="this.sign.type"><label>学生会员</label>
        <input type="radio" name="radios2" value="B" v-model="this.sign.type"><label>学生非会员</label>
        <input type="radio" name="radios2" value="C" v-model="this.sign.type"><label>非学生会员</label>
        <input type="radio" name="radios2" value="D" v-model="this.sign.type"><label>非学生非会员</label>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="27">
        <span>审核状态：</span>
      </el-col>
      <el-col :span="27">
        <input type="radio" name="radios3" value="A" v-model="this.sign.signState"><label>待审核</label>
        <input type="radio" name="radios3" value="B" v-model="this.sign.signState"><label>通过</label>
        <input type="radio" name="radios3" value="C" v-model="this.sign.signState"><label>未通过</label>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>姓：<el-input v-model="this.sign.firstName" placeholder="请输入姓"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>名：<el-input v-model="this.sign.lastName" placeholder="请输入名"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0;">
      <el-col :span="7">
        <span>性别：</span>
      </el-col>
      <el-col :span="7">
        <input type="radio" name="radios4" value="f" v-model="this.sign.gender"><label>女</label>
        <input type="radio" name="radios4" value="m" v-model="this.sign.gender"><label>男</label>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>国籍：<el-input v-model="this.sign.nationality" placeholder="请输入国籍"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      出生日期：
      <el-col :span="24">
        <el-date-picker
            v-model="this.sign.birthDateStr"
            type="date"
            placeholder="Choose date">
        </el-date-picker>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>附属机构：<el-input v-model="this.sign.affiliation" placeholder="请输入附属机构"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>机构地址：<el-input v-model="this.sign.position" placeholder="请输入机构地址"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>研究兴趣：<el-input v-model="this.sign.researchInterests" placeholder="请输入研究兴趣"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>联系地址：<el-input v-model="this.sign.contactAddress" placeholder="请输入联系地址"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>电话：<el-input v-model="this.sign.telephone" placeholder="请输入电话"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>电子邮箱：<el-input v-model="this.sign.email" placeholder="请输入电子邮箱"></el-input></span>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0 0 0" >
      <el-col :span="24">
        <span>审核意见：<el-input v-model="this.sign.comments" placeholder="请输入审核意见"></el-input></span>
      </el-col>
    </el-row>
    <el-button @click="processOk(this.sign.id)">通过</el-button>
    <el-button @click="processNo(this.sign.id)">不通过</el-button>
  </el-dialog>-->
</template>

<script>
import {ElMessage} from "element-plus";
import time from '@/core/time.js'
// import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'
// import Vue from 'vue'
// Vue.use(Viewer)
export default {
  name: "Process",
  data(){
    return {
      tableData: [],
      dialog1:false,
      dialog2:false,
      sign:{},
      price:-1,
      sign2:{},
      totalNum:0,pageNum:1,pageSize:20,
      images:[],
      images2:[],
      options: [{
        value: '加元',
        label: '加元'
      }, {
        value: '美元',
        label: '美元'
      }, {
        value: '人民币',
        label: '人民币'
      }],
      value: ''
    }
  },
  created() {
    this.listProcess()

  },
  mounted() {
  },
  methods:{

    openDialog1(data){
      console.log('查看数据：',data)
      this.sign2.id = data.id
      this.sign2.firstName = data.firstName
      this.sign2.birthDateStr = data.birthDateStr
      this.sign2.amount = data.amount
      this.sign2.currency = data.currency
      this.sign2.isReceipt = data.isReceipt
      this.sign2.type = data.type
      this.sign2.signState = data.signState
      this.sign2.lastName = data.lastName
      this.sign2.gender = data.gender
      this.sign2.nationality = data.nationality
      this.sign2.affiliation = data.affiliation
      this.sign2.position = data.position
      this.sign2.researchInterests = data.researchInterests
      this.sign2.contactAddress = data.contactAddress
      this.sign2.telephone = data.telephone
      this.sign2.comments = data.comments
      this.sign2.email = data.email
      this.sign2.questionOne = data.questionOne
      this.sign2.questionTwo = data.questionTwo
      this.sign2.questionThree = data.questionThree
      this.dialog1 = true;
      this.getPictures(data.id)
    },
    listProcess(){
      let data = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
      }
      let url = "/sign/selectSign";
      this.$request.post(url,data).then(res=>{
        this.tableData = res.obj.list;
        // console.log("this.tableData",this.tableData)
        // debugger
        this.totalNum = res.obj.total;
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].username = this.tableData[i].firstName+this.tableData[i].lastName
          this.tableData[i].amount = this.tableData[i].amount/100
          this.tableData[i].year = this.tableData[i].createTime.substring(0,4);
          this.tableData[i].month = this.tableData[i].createTime.substring(5,7);
          this.tableData[i].day = this.tableData[i].createTime.substring(8,10);
          this.tableData[i].createTime = time.formateDate(this.tableData[i].createTime)
        }
        // for(let item of this.tableData){
        //   item.year=item.createdDate.substring(0,4);
        //   item.month=item.createdDate.substring(5,7);
        //   item.day=item.createdDate.substring(8,10);
        //   // this.$set(item,"year",item.createdDate.substring(0,4));
        //   // this.$set(item,"month",item.createdDate.substring(5,7));
        //   // this.$set(item,"day",item.createdDate.substring(8,10));
        //   item.createdDate = time.formateDate(item.createdDate);
        // }
        console.log(this.tableData,'123456789')
      })
    },
    exportSignData(){
      let url = "/sign/downloadSignData"
      window.open(window.location.origin + '/api3' + url)
    },

    handleInput2(e) {
      // 通过正则过滤小数点后两位
      e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
    },

    /**
     *   通过身份、线上线下来确认费用
     */

    confirmExpenses(signTime){
      // var nowDate = new Date();
      // let m = nowDate.getMonth()+1
      // let today = nowDate.getFullYear() +'-'+ m +"-"+ nowDate.getDate()+' '+ nowDate.getHours() +':'+ nowDate.getMinutes()
      console.log('报名时间：',signTime)
      let today = signTime
      let date1='2025-5-21 00:00'
      date1 = new Date(date1).getTime();
      today = new Date(today).getTime();
      console.log('参与方式：',this.sign2.participateMethod)
        if (today<date1) {
          //身份信息
          if (this.sign2.type == 'A') {
            // this.sign2.price = 0
            this.sign2.howMuchRMB = 3000
            this.sign2.howMuchCAD = 600
          } else if (this.sign2.type == 'B') {
            // this.sign2.price = 0
            this.sign2.howMuchRMB = 3500
            this.sign2.howMuchCAD = 700
          } else if (this.sign2.type == 'C') {
            // this.sign2.price = 35
            this.sign2.howMuchRMB = 1500
            this.sign2.howMuchCAD = 300
          } else if (this.sign2.type == 'D') {
            // this.sign2.price = 70
            this.sign2.howMuchRMB = 4000
            this.sign2.howMuchCAD = 800
          }
        }
        else if (today>=date1){
          //身份信息
          if (this.sign2.type == 'A') {
            // this.sign2.price = 50
            this.sign2.howMuchRMB = 3500
            this.sign2.howMuchCAD = 650
          } else if (this.sign2.type == 'B') {
            // this.sign2.price = 50
            this.sign2.howMuchRMB = 4000
            this.sign2.howMuchCAD = 750
          } else if (this.sign2.type == 'C') {
            // this.sign2.price = 85
            this.sign2.howMuchRMB = 2000
            this.sign2.howMuchCAD = 400
          } else if (this.sign2.type == 'D') {
            // this.sign2.price = 120
            this.sign2.howMuchRMB = 4500
            this.sign2.howMuchCAD = 850
          }
        }
      else {
        alert('费用计算失败，请联系管理员')
      }
      this.title = this.$t('sign_up.pay.title1') + '\xa0' + this.typeName + this.$t('sign_up.pay.title2') + '\xa0' + this.howMuch + '\xa0' + this.$t('sign_up.pay.title3')
    },

    processThis(data){
      console.log('cswwwwww')
      this.sign2.id = data.id
      this.sign2.amount = data.amount
      this.sign2.currency = data.currency
      this.sign2.firstName = data.firstName;
      this.sign2.birthDateStr = data.birthDateStr
      this.sign2.isReceipt = data.isReceipt
      this.sign2.type = data.type
      this.sign2.signState = data.signState
      this.sign2.lastName = data.lastName
      this.sign2.gender = data.gender
      this.sign2.nationality = data.nationality
      this.sign2.affiliation = data.affiliation
      this.sign2.position = data.position
      this.sign2.researchInterests = data.researchInterests
      this.sign2.contactAddress = data.contactAddress
      this.sign2.telephone = data.telephone
      this.sign2.email = data.email
      this.sign2.questionOne = data.questionOne
      this.sign2.questionTwo = data.questionTwo
      this.sign2.questionThree = data.questionThree
      this.sign2.year = data.createTime.substring(0,4);
      this.sign2.month = data.createTime.substring(5,7);
      this.sign2.day = data.createTime.substring(8,10);
      this.sign2.createTime=data.createTime;
      this.sign2.participateMethod=data.participateMethod;
      this.dialog1 = true;
      this.confirmExpenses(data.createTime)//计算费用
      this.getPictures(data.id)
      this.getPictures2(data.id)
    },

      getPictures(id){
        let data = {
          id: id
        };
        console.log("id",id)
        // debugger
        let url = "/sign/getPictures";
        this.$request.post(url, data).then((data) => {
          console.log('data============',data)
          this.images = data.obj
          console.log("len",this.images.length)
          // debugger
          for(let i=0;i<this.images.length;i++){

            this.images[i]=window.location.origin+'/api3/'+this.images[i];

          }
          console.log(this.images)
          debugger
        });
      },

    getPictures2(id){
      let data = {
        id: id
      };
      let url = "/sign/getPictures2";
      this.$request.post(url, data).then((data) => {
        console.log('data============',data)
        this.images2 = data.obj
        for(let i=0;i<this.images2.length;i++){
          this.images2[i]=window.location.origin+'/api3/'+this.images2[i];
          // console.log(this.imges[i])
        }
      });
    },
    /*processOk(id){
      this.dialog1 = false
      this.dialog2 = false
      let that = this;
      let data = {
        id: id,
        firstName: this.sign.firstName,
        birthDateStr:this.sign.birthDateStr,
        isReceipt:this.sign.isReceipt,
        type:this.sign.type,
        signState:this.sign.signState,
        lastName:this.sign.lastName,
        gender:this.sign.gender,
        nationality:this.sign.nationality,
        affiliation:this.sign.affiliation,
        position:this.sign.position,
        researchInterests:this.sign.researchInterests,
        contactAddress:this.sign.contactAddress,
        telephone:this.sign.telephone,
        email:this.sign.email,
        amount:this.sign.amount,
        currency:this.sign.currency,
        comments:this.sign.comments
      };
      let url = "/sign/processOk";
      this.$request.post(url, data).then((data) => {
        // if(data.obj=="审核成功"){
        //   ElMessage({
        //     type: 'success',
        //     message: "审核成功",
        //   })
        // }
        location. reload()
      });
    },*/

    processOk1(id){
      this.dialog1 = false
      let that = this;
      let data = {
        id: id,
        signState:this.sign2.signState,
        amount:this.sign2.amount*100,
        currency:this.sign2.currency,
        comments:this.sign2.comments
      };
      console.log("data",data)
      debugger
      let url = "/sign/processOk1";
      this.$request.post(url, data).then((data) => {
        this.sign2.comments=''
        this.sign2.amount=''
        this.sign2.currency=''
        if(this.sign2.signState=='B'){
          /**
           * 发送审核通过短信
           */
          this.approvedSendMsg();
        }else if(this.sign2.signState=='C'){
          /**
           * 发送审核不通过短信
           */
          this.failedSendMsg();
        }
        this.listProcess();
      });
    },
    /**
     * 发送审核通过短信
     */
    approvedSendMsg(){
      let data ={
        sendTo:this.sign2.email,
        subject:"IEEE国际暑期学校报名审核已通过（IEEE International Summer School Registration Review Passed）",
        text:"IEEE国际暑期学校报名审核已通过（IEEE International Summer School Registration Review Passed）"
      }
      let url = "/mail/sendSimpleMailMessage"
      this.$request.post(url, data).then((data) => {
        console.log('data============',data)
        debugger
        if(data.obj=="failed"){
          this.$message({
            type: 'warning',
            message: "邮箱发送不成功！"
            // message: '审核结果已发送至报名者邮箱'
          })
        }
        else if(data.obj=="success"){
          this.$message({
            type: 'success',
            // message: "邮箱地址错误！发送失败！"
            message: '审核结果已发送至报名者邮箱'
          })
        }

      });
    },
    /**
     * 发送审核不通过短信
     */
    failedSendMsg(){
      let data ={
        sendTo:this.sign2.email,
        subject:"IEEE国际暑期学校报名审核未通过，请登录网站：http://www.e-cargoschool.com/#/，查看不通过原因并重新上传资料（IEEE International Summer School registration review failed. Please log in to the website: http://www.e-cargoschool.com/#/ , check the reason for the failure and upload the information again）",
        text:"IEEE国际暑期学校报名审核未通过，请登录网站：http://www.e-cargoschool.com/#/，查看不通过原因并重新上传资料（IEEE International Summer School registration review failed. Please log in to the website: http://www.e-cargoschool.com/#/ , check the reason for the failure and upload the information again）"
      }
      let url = "/mail/sendSimpleMailMessage"
      // this.$request.post(url, data).then((data) => {
      //   // console.log('data============',data)
      //   this.$message({
      //     type: 'success',
      //     message: '审核结果已发送至报名者邮箱'
      //   })
      // });
      this.$request.post(url, data).then((data) => {
        console.log('data============',data)
        debugger
        if(data.obj=="failed"){
          this.$message({
            type: 'warning',
            message: "邮箱发送不成功！"
            // message: '审核结果已发送至报名者邮箱'
          })
        }
        else if(data.obj=="success"){
          this.$message({
            type: 'success',
            // message: "邮箱地址错误！发送失败！"
            message: '审核结果已发送至报名者邮箱'
          })
        }

      });
    },


    /*processNo(id){
      this.dialog1 = false
      this.dialog2 = false
      let that = this;
      let data = {
        id: id,
        firstName: this.sign.firstName,
        birthDateStr:this.sign.birthDateStr,
        isReceipt:this.sign.isReceipt,
        type:this.sign.type,
        signState:this.sign.signState,
        lastName:this.sign.lastName,
        gender:this.sign.gender,
        nationality:this.sign.nationality,
        affiliation:this.sign.affiliation,
        position:this.sign.position,
        researchInterests:this.sign.researchInterests,
        contactAddress:this.sign.contactAddress,
        telephone:this.sign.telephone,
        email:this.sign.email,
        amount:this.sign.amount,
        currency:this.sign.currency,
        comments:this.sign.comments
      };
      let url = "/sign/processNo";
      this.$request.post(url, data).then((data) => {
        location. reload()
      });
    },*/
    //改变页码大小
    handleSizeChange(pageSize){
      this.pageSize = pageSize;
      this.listProcess()
    },
    //跳转页码
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.listProcess()
    },
  }
}
</script>

<style lang="less">
.table-board{
  width: 100%;
}
.processList{
  width: 100%;
  height: 100%;
  background: white;
  .processrows_box{
    height: 90%;
    border-radius:20px;
    background: white;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 2.5%;
    box-shadow: 0px 0px 10px 0 #d0d2d3;
    .processrows{
      margin:auto;
      width:860px;
      padding-top: 50px;
      .row_box{
        width:860px;
      }
      .row {
        height: 80px;
        width: 840px;
        border-bottom: 2px dotted #D4D4DC;
        .row_date{
          display: flex;
          float: left;
          width: 82px;
          .row_date_left{
            height: 60px;
            margin-top: 20px;
            font-size: 35px;
            line-height: 70px;
          }
          .row_date_right{
            height: 40px;
            margin-top: 34px;
            padding-left: 5px;
            .row_date_month{
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
            .row_date_year{
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
          }

        }
        .row_content{
          margin-top: 40px;
          line-height: 40px;
          height: 30px;
          padding-left: 20px;
          margin-left: 10px;
          width: 600px;
          float: left;
          border-left: 6px solid #CDD9E9;
          .row_sign {
            overflow: hidden;
            width: 400px;
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow:hidden;
            float: left;
          }
          .row_name2{
            font-size: 13px;
            width: 200px;
            color: #a8a8ac;
            float: right;
            text-align: right;
          }
        }
        .el-button{
          background: #3A63B3;
          height: 20px;
          width: 80px;
          margin-top: 45px;
          margin-right: 30px;
          font-size: 13px;
          line-height: 2px;
          border-radius:0;
          float: right;
        }
      }
    }
    .page{
      height: 100px;
      width: 860px;
      margin:auto;
      position: relative;
      .el-pager{
        li{
          border: 1px solid #dcdfe6;
          margin-right: 10px;
          background-color: white;
        }
        li:not(.disabled).active{
          background-color: #3A62FE;
          color: white;
        }
        li:hover {
          color: #3A62FE;
        }
      }
      .btn-prev{
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        margin-left: 10px;
        background-color: white;
      }
      .btn-next{
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        background-color: white;
      }
      .el-pagination{
        position: absolute;
        bottom: 30px;
        right: 0;
        .el-pagination__sizes{
          float: right;
          .el-input__inner{
            color: #5D61AA;
            font-weight: bold;
          }
        }
      }
    }
  }
}
.demo-image__error .image-slot {
  font-size: 30px;
}
.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}
.demo-image__error .el-image {
  width: 100%;
  height: 200px;
}
.hand-up{
  color: red;
  font-size: large;
  margin-bottom: 20px;
}
</style>
